import { useQuery } from "@tanstack/react-query";

import { getProperties } from "api/tenants";
import { queryKeys } from "./queryKeys";

import { PaginationTable, Property } from "js/components/types";

interface UseGetPropertiesOptions {
  pagination?: PaginationTable;
  enabled?: boolean;
}

export const useGetProperties = (options: UseGetPropertiesOptions = {}) => {
  const { pagination, enabled = true } = options;

  const paginationKey = pagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
      }
    : undefined;

  return useQuery({
    queryKey: queryKeys.properties.list(paginationKey),
    queryFn: async (): Promise<Property[]> => {
      return await getProperties(pagination);
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
